// extracted by mini-css-extract-plugin
export default {"front":"style_front__oLLRo","bText":"style_bText__GjBCn","sText":"style_sText__q27T0","left":"style_left__u72Pt","image":"style_image__jbTh1"};